export default __webpack_public_path__ + "static/media/f_socialmediaslider.98c8028f.svg";